import { useContext, useMemo } from 'react';
import { RoleUIContext } from './role-ui-context';

export interface ColumnLike {
  id: string;
  hidden?: boolean;
}

/**
 * Filters a column definitions array using UEAC element map.
 * Any column whose element_key maps to visibility='hidden' is removed.
 * Columns with col.hidden=true are also removed (pre-existing logic).
 *
 * Place this in the component that builds the columns array before passing
 * to DataTable, e.g.:
 *   const cols = useVisibleColumns(allColumns)
 *   return <DataTable columns={cols} ... />
 */
export function useVisibleColumns<T extends ColumnLike>(columns: T[]): T[] {
  const ctx = useContext(RoleUIContext);
  const elementMap = ctx?.elementMap;

  return useMemo(
    () =>
      columns.filter((col) => {
        if (col.hidden) return false;
        if (!elementMap) return true;
        const rule = elementMap.get(col.id);
        return !rule || rule.visibility !== 'hidden';
      }),
    [columns, elementMap],
  );
}
